import * as PIXI from 'pixi.js';
export function isWebGlWarningForced() {
    const params = new URLSearchParams(window.location.search);
    return params.get('forceWebGlWarning') === 'true';
}
export function getIsWebGlSupportedViaPixiUtil() {
    return PIXI.utils.isWebGLSupported();
}
export function getIsWebGlSupportedViaCanvasContext() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return !!ctx;
}
export function getWebGlParameters() {
    const canvasElement = document.createElement('canvas');
    const gl = canvasElement.getContext('webgl') || canvasElement.getContext('experimental-webgl');
    if (!gl) {
        return {};
    }
    if (!('getParameter' in gl)) {
        return {};
    }
    const webGlParameters = {};
    const GL_FIELDS = [
        'VERSION',
        'RENDERER',
        'MAX_TEXTURE_SIZE',
        'MAX_TEXTURE_IMAGE_UNITS',
        'SHADING_LANGUAGE_VERSION',
        'MAX_RENDERBUFFER_SIZE'
    ];
    GL_FIELDS.forEach((glField) => {
        const key = `WebGL ${glField}`;
        const rawParameterValue = gl.getParameter(WebGLRenderingContext[glField]);
        if (typeof rawParameterValue === 'string') {
            webGlParameters[key] = rawParameterValue;
        }
        else if (typeof rawParameterValue === 'number') {
            webGlParameters[key] = `${rawParameterValue}`;
        }
    });
    return webGlParameters;
}
